import sensors from './dataStatistics'
export const commonJs = {
    isIos() {
        const u = navigator.userAgent;
        if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
            return true;
        }
        return false;
    },
    goLogin(successCb, failCb) {
        window.authlevel.init({
            auth_level: this.$isIos() ? 1 : 3,
            authLevelChange: {
                success: res => {
                    successCb && successCb(res)
                },
                fail: res => {
                    failCb && failCb(res)
                }
            }
        });
    },
    sensors
}
export default {
    install(Vue, options) {
        if (this.installed) return
        this.installed = true
        const obj = {}
        Object.keys(commonJs).forEach(item => {
            obj[`$${item}`] = {
                get() {
                    return commonJs[item]
                }
            }
        })
        Object.defineProperties(Vue.prototype, obj)
    }
}



// WEBPACK FOOTER //
// ./src/utils/commonJs.js